module.exports = __webpack_public_path__ + "static/assets/f3cf0362482c9964bd5ff85c09c3bcea.png";